import { API } from '@/utils/configs/axios.config'
import { IHmsTokens } from '@/types/auth.interface'
import { IOrderRequestData } from '@/types/order/order-request-data.interface'
import { toFormData } from 'axios'
import ICaptchaResponse from '@/types/captcha-response.interface'

const AuthService = {
  async authHms(login: string, password: string, mfaCode?: string) {
    const tokens = (
      await API.post<IHmsTokens>(
        '/oauth/token',
        toFormData({
          grant_type: 'password',
          client_id: 'frontend_app',
          client_secret: 'frontend_app_secret',
          username: login,
          password: password,
          mfa_code: mfaCode,
        })
      )
    ).data

    return tokens
  },

  async resetPasswordHms(login: string, sms_code?: string) {
    const response = (
      await API.post('/password-recovery', {
        accountId: login,
        sms_code,
      })
    ).data

    return response
  },

  async authControl2(login: string, password: string) {
    const response = (
      await API.post(
        'https://control2.majordomo.ru/user/login/',
        toFormData({
          login: login,
          password: password,
        }),
        {
          headers: {
            accept: 'application/json',
            'x-requested-with': 'XMLHttpRequest',
          },
          withCredentials: true,
        }
      )
    ).data

    return response
  },

  async resetPasswordControl2(login: string) {
    const response = (
      await API.post(
        'https://control2.majordomo.ru/user/resetpass/',
        toFormData({
          crit: login,
        }),
        {
          headers: {
            accept: 'application/json',
            'x-requested-with': 'XMLHttpRequest',
          },
          withCredentials: true,
        }
      )
    ).data

    return response
  },

  async register(data: IOrderRequestData) {
    const response = (await API.post('/public/api/v1/register', data)).data

    return response
  },

  async getCaptcha() {
    const response = (await API.get<ICaptchaResponse>('/public/api/v1/captcha')).data

    return response
  },
}

export default AuthService
